/**
 * PLEASE READ BEFORE ADDING A NEW EXPERIMENT:
 * 1. Add your experiment to the AMPLITUDE_EXPERIMENTS_LIST list at the bottom to help keep track of all the experiments in the app
 * 2. If you want to use your experiment in the Amplitude context(which means it gets fetched on app load), add it to the AMPLITUDE_CONTEXT_EXPERIMENTS_LIST below
 * PLEASE DO NOT ADD TO THE AMPLITUDE CONTEXT if you want to bucket the experiment in a component
 * 3. Opendoor webviews:
 * -  You want it to appear on the Opendoor mobile app webviews: add it to the WEBVIEW_EXPERIMENTS_ALLOWLIST below
 * -  You don't want it to appear on the Opendoor mobile app webviews: add it to the WEBVIEW_EXPERIMENTS_OPT_OUT_LIST below
 */

export const OFFER_CONFIDENCE_LEVEL_EXPERIMENT = 'pg-24-04-offer-confidence-v1';
export const LOW_OFFER_CONFIDENCE_EXPERIMENT_V1 = 'pg-24-05-low-offer-confidence-v1';
export const HIGH_OFFER_CONFIDENCE_EXPERIMENT_V2 = 'pg-24-05-high-offer-confidence-v2';

export const FINAL_OFFER_REPAIRS_LANGUAGE_EXPERIMENT =
  'seller-24-07-experiment-final-offer-repairs-language';

export enum UNTREATED_ROOM_CONDITION_PRICING {
  CONTROL = 'control',
  MODAL = 'modal',
  CLOSABLE_MODAL = 'closable_modal',
}

export enum STANDARD_EXPERIMENT_VARIATIONS {
  CONTROL = 'control',
  TREATMENT = 'treatment',
}

/**
 * WARNING!!!!!!!!
 * These experiments fetched on app load
 * DO NOT add to this list if you are calling getAmplitudeExperiment in a component
 */
export enum AMPLITUDE_CONTEXT_EXPERIMENTS_LIST {}
export const AMPLITUDE_CONTEXT_EXPERIMENTS: Record<
  AMPLITUDE_CONTEXT_EXPERIMENTS_LIST,
  { defaultValue: string }
> = {};

/**
 * NOTE: If you want your experiment to run in the Opendoor mobile app, you
 * need to add it to the whitelist below. Please test your experiment in the
 * mobile app before adding it below to make sure it behaves as intended.
 * Instructions here: https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2317353092/Experimentation+Feature+Flagging+With+Amplitude#How-to-test-that-your-FF/Experiment-is-showing-up-on-WebViews
 */
export const WEBVIEW_EXPERIMENTS_ALLOWLIST: string[] = [OFFER_CONFIDENCE_LEVEL_EXPERIMENT];

export const WEBVIEW_EXPERIMENTS_OPT_OUT_LIST: string[] = [
  // do not remove experimentKey as this is used for a test
  'experimentKey',
  LOW_OFFER_CONFIDENCE_EXPERIMENT_V1,
  HIGH_OFFER_CONFIDENCE_EXPERIMENT_V2,
  FINAL_OFFER_REPAIRS_LANGUAGE_EXPERIMENT,
];

/**
 * Helps us keep track of all the experiments in the app
 */
export type AMPLITUDE_EXPERIMENT_LIST_TYPES =
  // do not remove experimentKey as this is used for a test
  | 'experimentKey'
  | typeof OFFER_CONFIDENCE_LEVEL_EXPERIMENT
  | typeof LOW_OFFER_CONFIDENCE_EXPERIMENT_V1
  | typeof HIGH_OFFER_CONFIDENCE_EXPERIMENT_V2
  | typeof FINAL_OFFER_REPAIRS_LANGUAGE_EXPERIMENT;

export const AMPLITUDE_EXPERIMENTS_LIST: AMPLITUDE_EXPERIMENT_LIST_TYPES[] = [
  'experimentKey',
  OFFER_CONFIDENCE_LEVEL_EXPERIMENT,
  LOW_OFFER_CONFIDENCE_EXPERIMENT_V1,
  HIGH_OFFER_CONFIDENCE_EXPERIMENT_V2,
  FINAL_OFFER_REPAIRS_LANGUAGE_EXPERIMENT,
];
